import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import TrackerLogin from "components/TrackerLogin";
import { GOOGLE_API_KEY } from "constants/common";
import useTrackPassenger from "hooks/tracker/useTrackPassenger";
import { Alert } from "antd";

export default function TrackSchoolCarpooling() {
  const { data, isAuthenticated, handleCloseLogin, error } = useTrackPassenger();

  return (
    <div className="w-full h-screen relative">
      <APIProvider apiKey={GOOGLE_API_KEY}>
        <Map
          defaultZoom={14}
          maxZoom={40}
          minZoom={10}
          defaultCenter={{
            lat: data?.latitude ?? 13.496494229233356,
            lng: data?.longitude ?? 39.47494624044569,
          }}
        >
          {data && (
            <Marker
              optimized
              position={{
                lat: data.latitude,
                lng: data.longitude,
              }}
            />
          )}
        </Map>
      </APIProvider>
      {!isAuthenticated && <TrackerLogin handleClose={handleCloseLogin} />}
      {isAuthenticated && error && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-10 w-96">
          <Alert
            message="No Location Data"
            description={error}
            type="warning"
            showIcon
            closable
          />
        </div>
      )}
      {isAuthenticated && data && !data.has_ongoing_trip && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-10 w-96">
          <Alert
            message="No Active Trip"
            description="The passenger currently has no ongoing trip."
            type="info"
            showIcon
          />
        </div>
      )}
    </div>
  );
}
